import { Fetcher } from '@this/src/util';
import type { GoogleReviews } from '../types/proposalItemGoogleReviews';

type GoogleReviewResponse = {
  author_name: string;
  rating: number;
  relative_time_description: string;
  text: string;
};

type GoogleReviewsResponse = {
  rating: number | null;
  user_ratings_total: number | null;
  reviews: GoogleReviewResponse[] | null;
};

type ProposalItemGoogleReviewsResponse = {
  google_reviews: GoogleReviewsResponse | null;
};

const mapGoogleReviewsResponse = (response: GoogleReviewsResponse | null): GoogleReviews => {
  if (response == null) {
    return {
      rating: null,
      userRatingsTotal: null,
      reviews: []
    };
  }

  return {
    rating: response.rating,
    userRatingsTotal: response.user_ratings_total,
    reviews: (response.reviews || []).map(review => ({
      authorName: review.author_name,
      rating: review.rating,
      relativeTimeDescription: review.relative_time_description,
      text: review.text
    }))
  };
};

export const fetchProposalItemGoogleReviews = async (
  tripId: string,
  itemId: number,
  signal?: AbortSignal
): Promise<GoogleReviews> => {
  const response = await Fetcher.get<ProposalItemGoogleReviewsResponse>(
    `/trips/${tripId}/ai_proposal_items/${itemId}/google_reviews.json`,
    undefined,
    undefined,
    signal
  );
  return mapGoogleReviewsResponse(response.google_reviews);
};
